import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

const REASONS = [
  {
    num: "01",
    title: "Verified drivers",
    copy: "Every driver behind the wheel is licence-checked and route-trained before their first pickup. You are never a stranger's passenger.",
  },
  {
    num: "02",
    title: "Honest meters",
    copy: "The quoted fare is the final fare. Toll, parking and border charges are the only additions — and they come at actuals, never inflated.",
  },
  {
    num: "03",
    title: "Cars that show up",
    copy: "Sedan or SUV, every vehicle is cleaned, serviced and cooled before it reaches your door. The aircon in Aircon Travel is a promise, not a name.",
  },
];

export default function WhyUs() {
  return (
    <section className="bg-paper text-ink">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 36 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.65, ease: EASE }}
          className="lg:col-span-5"
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-signal-deep mb-4">
            (06) — Why Aircon Travel
          </p>
          <h2 className="font-display font-black uppercase leading-[0.95] text-4xl sm:text-5xl lg:text-6xl">
            Driven right.
            <br />
            Every time.
          </h2>
          <div className="mt-10 border-l-4 border-signal overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1564668836804-05a2de350bb6?q=85&w=1600&auto=format&fit=crop"
              alt="Highway at night"
              loading="lazy"
              className="w-full aspect-[4/3] object-cover"
            />
          </div>
        </motion.div>

        <div className="lg:col-span-7 flex flex-col justify-center">
          {REASONS.map((r, i) => (
            <motion.div
              key={r.num}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, ease: EASE, delay: i * 0.08 }}
              className="border-t border-ink/15 py-8 md:py-10 last:border-b"
            >
              <div className="flex gap-6 md:gap-10 items-start">
                <span className="font-mono text-sm text-signal-deep mt-2">{r.num}</span>
                <div>
                  <h3 className="font-display uppercase text-2xl md:text-3xl mb-3">{r.title}</h3>
                  <p className="text-ink/70 leading-relaxed text-base">{r.copy}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
